"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _sliceInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/slice");
var _Array$from = require("@babel/runtime-corejs3/core-js-stable/array/from");
var _Symbol = require("@babel/runtime-corejs3/core-js-stable/symbol");
var _getIteratorMethod = require("@babel/runtime-corejs3/core-js/get-iterator-method");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SurveyJSFormRenderer;
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var Survey = _interopRequireWildcard(require("survey-react"));
var _lodash = require("lodash");
var _DropdownMultiselectWidget = require("../Widgets/DropdownMultiselectWidget");
var _DropdownWidget = require("../Widgets/DropdownWidget");
var _CalendarWidget = require("../Widgets/CalendarWidget");
var _buildResponses = _interopRequireDefault(require("./buildResponses"));
var _utils = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof _Symbol !== "undefined" && _getIteratorMethod(o) || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { var _context4; if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = _sliceInstanceProperty(_context4 = Object.prototype.toString.call(o)).call(_context4, 8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
(0, _DropdownMultiselectWidget.init)(Survey);
(0, _DropdownWidget.init)(Survey);
(0, _CalendarWidget.init)(Survey);

// Override global messages
Survey.surveyStrings.invalidExpression = "Expression is invalid";

// Adding custom property uuid to the question, and each choices
Survey.Serializer.addProperty("question", {
  name: "uuid:string",
  category: "general",
  readOnly: true,
  visible: true
});
Survey.Serializer.addProperty("itemvalue", {
  name: "uuid:string",
  category: "general",
  readOnly: true,
  visible: true
});

// Adding custom property to the question, and each choices
Survey.Serializer.addProperty("question", {
  name: "custom",
  category: "general",
  readOnly: false,
  visible: true
});
Survey.Serializer.addProperty("itemvalue", {
  name: "custom",
  category: "general",
  readOnly: true,
  visible: true
});
function SurveyJSFormRenderer(_ref) {
  var _ref$formData = _ref.formData,
    formData = _ref$formData === void 0 ? {} : _ref$formData,
    formSubmission = _ref.formSubmission,
    editMode = _ref.editMode,
    handleSetSurveyModel = _ref.handleSetSurveyModel,
    _ref$enableAccessibil = _ref.enableAccessibilityHacks,
    enableAccessibilityHacks = _ref$enableAccessibil === void 0 ? false : _ref$enableAccessibil,
    _ref$onValueChanged = _ref.onValueChanged,
    onValueChanged = _ref$onValueChanged === void 0 ? null : _ref$onValueChanged;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    model = _useState2[0],
    setModel = _useState2[1];
  (0, _react.useEffect)(function () {
    var configuration = formData.configuration;
    if (configuration) {
      // Replace id with uuid
      var json = (0, _utils.replaceIdWithUUID)(configuration);
      var newModel = new Survey.Model(json);
      onValueChanged && newModel.onValueChanged.add(onValueChanged);
      newModel.showCompletedPage = false;

      //If there is a submission data, we need to fill the form with it
      if (!(0, _lodash.isEmpty)(formSubmission)) {
        var data = {};
        formSubmission.responses.forEach(function (item) {
          var deprecateResponse = false;
          var value = String(!(0, _lodash.isNil)(item.value) ? item.value : "");
          var question = newModel.getQuestionByName(item.name);
          // if value has a comma it means we have multiples values (eg: dropdown-multiselect)
          if ((0, _indexOf.default)(value).call(value, ",") !== -1) {
            value = value.split(",");
          }
          // if value has no comma but has maxSelextedChoices as a property it means it should be in an array (eg: dropdown-multiselect)
          else if (question && (question === null || question === void 0 ? void 0 : question.maxSelectedChoices) >= 0) {
            value = [value];
          }
          // check for validity of old submission values against current survey/form choice options
          if (question && !(0, _lodash.isEmpty)(question === null || question === void 0 ? void 0 : question.choices)) {
            // multi-choice iteration
            if (Array.isArray(value)) {
              var invalidValues = new Array();
              value.forEach(function (v) {
                var _context;
                var validChoice = (0, _find.default)(_context = question.choices).call(_context, function (c) {
                  return c.value === v;
                });
                if (!validChoice) {
                  invalidValues.push(v);
                }
              });
              var validValues = (0, _filter.default)(value).call(value, function (v) {
                return !(0, _includes.default)(invalidValues).call(invalidValues, v);
              });
              // if all values map to deprecated choices, deprecate response
              if (validValues.length === 0) {
                deprecateResponse = true;
              } else {
                value = (0, _toConsumableArray2.default)(validValues);
              }
            }
            // single-choice iteration
            else {
              var _context2;
              var validChoice = (0, _find.default)(_context2 = question.choices).call(_context2, function (c) {
                return c.value === value;
              });
              if (!validChoice) {
                deprecateResponse = true;
              }
            }
          }
          if (!deprecateResponse) {
            data[item.name] = value;
          }
        });
        newModel.data = data;
      }

      // For test only (when running in localhost the preview tab shows "Complete" button)
      // newModel.onComplete.add(function (sender, options) {
      //   console.log('responses', buildResponses(newModel))
      // })

      setModel(newModel);
      handleSetSurveyModel(newModel);
    }
  }, [formSubmission]);

  // For readonly mode, show all the question with the answer
  if (!editMode) {
    var questionsNames = (0, _lodash.get)(model, "questionHashes.names", {});
    var responses = (0, _lodash.get)(formSubmission, "responses", []);
    var description = (0, _lodash.get)(model, "description", "");
    var answerAtLeastOne = "Answer at least one question for a preview to appear here.";
    if (responses.length === 0) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "normal-case answer-at-least-one"
      }, answerAtLeastOne);
    } else {
      var _context3;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "ui-form-renderer"
      }, description && /*#__PURE__*/_react.default.createElement("h5", {
        className: "mb-5 normal-case"
      }, description), (0, _map.default)(_context3 = (0, _keys.default)(questionsNames)).call(_context3, function (questionName) {
        var questionResponse = (0, _find.default)(responses).call(responses, function (r) {
          return r.name === questionName;
        });
        var isHtml = false;
        var title;
        var displayValue;
        var question = model.getQuestionByName(questionName);
        if (!question) {
          return;
        }
        if (question.conditionRunner && !model.runCondition(question.conditionRunner.expressionValue)) {
          return;
        }
        if (question.isVisible && question.getType() === "html") {
          isHtml = true;
          title = (0, _lodash.get)(question, "html");
          //Show HTML type elements
        } else if (!question.isVisible || !questionResponse) {
          //Hide unanswered question
          return;
        } else {
          title = questionResponse.title;
          displayValue = questionResponse.displayValue;
        }
        if (!displayValue && title === "") {
          return;
        }
        var displayLabel = isHtml ? /*#__PURE__*/_react.default.createElement("div", {
          className: "ui-form-renderer-question-display__label",
          dangerouslySetInnerHTML: {
            __html: title
          }
        }) : /*#__PURE__*/_react.default.createElement("div", {
          className: "ui-form-renderer-question-display__label"
        }, title);
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "ui-form-renderer-question-display",
          key: title
        }, displayLabel, /*#__PURE__*/_react.default.createElement("div", {
          className: "ui-form-renderer-question-display__value"
        }, displayValue));
      }));
    }
  }
  return model && /*#__PURE__*/_react.default.createElement(Survey.Survey, {
    model: model,
    showQuestionNumbers: "off",
    onUpdateQuestionCssClasses: function onUpdateQuestionCssClasses(survey, options) {
      // Custom css classes to match Unite Us styles
      var classes = options.cssClasses;
      classes.title += " ui-form-field__label ui-label-roman ui-label-roman--lowercase";
      if (options.question.getType() === "text") {
        classes.mainRoot += " ui-input-field ui-form-field";
      }
      if (options.question.getType() === "comment") {
        classes.mainRoot += " ui-text-field ui-form-field";
      }
      if (options.question.getType() === "radiogroup") {
        classes.mainRoot += " ui-radio-field ui-form-field";
      }
      if (options.question.getType() === "checkbox") {
        classes.mainRoot += " ui-checkbox-group ui-form-field";
        classes.item += " ui-checkbox-field ui-form-field";
        classes.controlLabel += " ui-form-field__label";
      }
      if (options.question.getType() === "dropdown-multiselect" || options.question.getType() === "dropdown" || options.question.getType() === "text" && options.question.inputType === "date") {
        classes.mainRoot = "sv_q overflow-visible";
      }
    },
    onAfterRenderQuestion: function onAfterRenderQuestion(survey, options) {
      if (enableAccessibilityHacks) {
        //Change surveyjs default question heading to label instead of h5
        options.htmlElement.querySelectorAll(".sv_q_title").forEach(function (el) {
          var replacement = document.createElement("label");
          // add existing h5 element attributes to the new label element
          if (el.hasAttributes()) {
            var _iterator = _createForOfIteratorHelper(el.attributes),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var attr = _step.value;
                replacement.setAttribute(attr.name, attr.value);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
          // set innerhtml of new label element
          replacement.innerHTML = el.innerHTML;
          // replace h5 with label
          el.replaceWith(replacement);
        });

        //Remove surveyjs question div validation aria attributes
        options.htmlElement.removeAttribute("aria-required");
        options.htmlElement.removeAttribute("aria-invalid");

        //Remove choicesjs aria attributes
        options.htmlElement.querySelectorAll(".choices__item").forEach(function (el) {
          el.removeAttribute("aria-selected");
        });
        options.htmlElement.querySelectorAll("[role=presentation]>div>.ui-select-field>div").forEach(function (el) {
          el.removeAttribute("aria-label");
        });
      }
    }
  });
}
//# sourceMappingURL=SurveyJSFormRenderer.js.map